import {Box, Typography} from '@mui/material';
import ArrButton from '../../../../../common/arr-button/ArrButton';
import './EditPanelDrawerHeader.scss';
import React from 'react';
import {t} from 'i18next';

interface PanelDrawerHeaderProps {
  onSave: () => void;
  onCancel: () => void;
  saveDisabled?: boolean;
}
const EditPanelDrawerHeader: React.FC<PanelDrawerHeaderProps> = ({
  onSave,
  onCancel,
  saveDisabled = false,
}) => {
  return (
    <Box className="edit-fields-header">
      <Typography
        className="edit-fields-title"
        data-testid={`edit-panel-drawer-header-edit-fields`}>
        {t('docView.editpanel.editFields')}
      </Typography>
      <Box className="edit-fields-actions">
        <ArrButton
          className="cancel-btn"
          variant="secondary"
          size="medium"
          onClick={onCancel}
          dataTestId="edit-panel-drawer-header-cancel-button">
          {t('docView.editpanel.cancel')}
        </ArrButton>

        <ArrButton
          className="save-btn"
          variant="primary"
          size="medium"
          type="submit"
          onClick={onSave}
          disabled={saveDisabled}
          dataTestId="edit-panel-drawer-header-save-button">
          {t('docView.editpanel.save')}
        </ArrButton>
      </Box>
    </Box>
  );
};

export default EditPanelDrawerHeader;
